/**
 * Normaliza a dígitos para https://wa.me/ (sin +). Alineado con Argentina móvil +549…
 */
export function waMeDigitsFromPhone(raw: string | null | undefined): string | null {
  if (!raw?.trim()) return null;
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 13 && digits.startsWith("549")) return digits;
  if (digits.length === 12 && digits.startsWith("54")) return `549${digits.slice(2)}`;
  if (digits.length === 10) return `549${digits}`;
  if (digits.length === 11 && digits.startsWith("0")) return `549${digits.slice(1)}`;
  if (digits.length >= 11 && digits.startsWith("549")) return digits;
  if (digits.length >= 8) return digits;
  return null;
}

export function whatsappChatUrl(raw: string | null | undefined): string | null {
  const d = waMeDigitsFromPhone(raw);
  if (!d) return null;
  return `https://wa.me/${d}`;
}
